import { render, staticRenderFns } from "./po_ord_two.vue?vue&type=template&id=418a5594&scoped=true&"
import script from "./po_ord_two.vue?vue&type=script&lang=js&"
export * from "./po_ord_two.vue?vue&type=script&lang=js&"
import style0 from "./po_ord_two.vue?vue&type=style&index=0&id=418a5594&scoped=true&lang=less&"
import style1 from "./po_ord_two.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a5594",
  null
  
)

export default component.exports